// src/components/frontend/Publications.js
import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faNewspaper,
    faHandsHelping,
    faExternalLinkAlt,
    faHeart,
    faUsers,
    faGraduationCap,
    faChild,
    faWheelchair,
    faLeaf,
    faUserMd,
    faPersonCane,
    faKitMedical,
    faBook,
    faHandHoldingHeart
} from '@fortawesome/free-solid-svg-icons';

const Publications = () => {
    // ============ PUBLICATIONS ============
    const publications = [
        {
            id: 1,
            name: 'Karnataka Police Magazine',
            description: 'Official monthly magazine covering Karnataka Police news, achievements, and community initiatives.',
            url: 'https://www.karnatakapolice.in',
            icon: 'https://www.karnatakapolice.in/karnatakapoliceapp/news_back_end_laravel/public/uploads/banners/banner_1781780312.png',
            category: 'Magazine',
            image: '/assets/img/publications/karnataka-police.jpg',
            color: '#1a237e'
        },
        {
            id: 2,
            name: 'Bangalore Metro News',
            description: 'Leading Kannada news platform covering Bengaluru\'s development, civic issues, and local stories.',
            url: 'https://bangaloremetronews.in',
            icon: 'https://bangaloremetronews.in/bangaloremetroapp/news_back_end_laravel/public/uploads/banners/banner_1783405863.png',
            category: 'News Portal',
            image: '/assets/img/publications/bangalore-metro.jpg',
            color: '#1a237e'
        },
        {
            id: 3,
            name: 'Venkatadri.in',
            description: 'Regional news platform delivering authentic updates on local events, politics, and community happenings.',
            url: 'https://venkatadri.in',
            icon: 'https://venkatadri.in/venkatadrinewsapp/news_back_end_laravel/public/uploads/banners/banner_1785754263.png',
            category: 'News Portal',
            image: '/assets/img/publications/venkatadri.jpg',
            color: '#1a237e'
        },

        {
            id: 4,
            name: 'Photo Journal',
            description: 'We deliver verified, high-impact news regarding police operations, legislative updates, public safety protocols, and strategic national security developments. ',
            url: 'https://photojournal.in',
            icon: '/assets/img/publications/Photo journal1.jpg',
            category: 'News Portal',
            image: '/assets/img/publications/national-police-tv.jpg',
            color: '#1a237e'
        },

        {
            id: 5,
            name: 'Camera News',
            description: 'Camera News is a regional news platform focused on bringing communities closer to the stories that matter most. We capture and share authentic updates through local events, politics, community happenings, and on-ground photography.',
            url: 'https://photojournal.in',
            icon: '/assets/img/publications/cn.jpg',
            category: 'News Portal',
            image: '/assets/img/publications/cn.jpg',
            color: '#1a237e'
        },
        
        {
            id: 6,
            name: 'National Police Magazine',
            description: 'India\'s premier digital news platform dedicated to police and law enforcement updates, safety tips, and national security news.',
            url: 'https://nationalpolicetv.in/',
            icon: 'https://nationalpolicetv.in/assets/img/logo/logo2025_2.png',
            category: 'News Portal',
            image: '/assets/img/publications/national-police-tv.jpg',
            color: '#1a237e'
        },
        {
            id: 7,
            name: 'Karnataka Police TV (YouTube)',
            description: 'Official YouTube channel for Karnataka Police News featuring updates, community initiatives, and public safety awareness programs.',
            url: 'https://www.youtube.com/@karnatakapolicenews',
            icon: '/assets/img/publications/ptv.png',
            category: 'YouTube Channel',
            image: '/assets/img/publications/karnataka-police-tv.jpg',
            color: '#1a237e'
        },
        {
            id: 8,
            name: 'Bangalore Metro News (YouTube)',
            description: 'YouTube channel covering Bengaluru\'s development, civic issues, and local stories through engaging video content.',
            url: 'https://www.youtube.com/@BangaloreMetroNews-tv',
            icon: '/assets/img/publications/mtv.png',
            category: 'YouTube Channel',
            image: '/assets/img/publications/bangalore-metro-tv.jpg',
            color: '#1a237e'
        }
    ];

    // ============ SERVICE AREAS ============
    const serviceAreas = [
        {
            title: 'Care for Senior Citizens',
            color: '#4fc3f7',
            icon: 'https://venkatadrisevatrust.com/assets/img/services/senior-citizens.png',
            fallbackIcon: faPersonCane,
            description: 'Providing assistance, essential supplies, emotional support, and healthcare aid to elderly people who need love and care.'
        },
        {
            title: 'Child Welfare',
            color: '#81c784',
            icon: 'https://venkatadrisevatrust.com/assets/img/services/child-welfare.png',
            fallbackIcon: faChild,
            description: 'Supporting underprivileged children through educational assistance, nutrition, school supplies, and opportunities for a brighter future.'
        },
        {
            title: 'Support for Persons with Disabilities',
            color: '#ffb74d',
            icon: 'https://venkatadrisevatrust.com/assets/img/services/disabilities.png',
            fallbackIcon: faWheelchair,
            description: 'Extending financial and material assistance, mobility aids, and rehabilitation support to differently-abled individuals.'
        },
        {
            title: 'Health & Medical Assistance',
            color: '#ef5350',
            icon: 'https://venkatadrisevatrust.com/assets/img/services/health-medical.png',
            fallbackIcon: faKitMedical,
            description: 'Helping economically disadvantaged patients with medical treatment, medicines, health camps, and emergency healthcare support.'
        },
        {
            title: 'Education for Poor Students',
            color: '#7e57c2',
            icon: 'https://venkatadrisevatrust.com/assets/img/services/education.png',
            fallbackIcon: faGraduationCap,
            description: 'Providing scholarships, school bags, books, uniforms, stationery, and other educational necessities to deserving students.'
        },
        {
            title: 'Environment & Nature Conservation',
            color: '#66bb6a',
            icon: 'https://venkatadrisevatrust.com/assets/img/services/environment.png',
            fallbackIcon: faLeaf,
            description: 'Promoting a greener tomorrow through tree plantation drives, environmental awareness programmes, and nature preservation initiatives.'
        },
        {
            title: 'Community Service',
            color: '#42a5f5',
            icon: 'https://venkatadrisevatrust.com/assets/img/services/community.png',
            fallbackIcon: faUsers,
            description: 'Organising relief activities, social welfare programmes, awareness campaigns, and humanitarian initiatives to uplift communities.'
        }
    ];

    // ============ IMPACT STORIES ============
    const impactStories = [
        {
            id: 1,
            title: 'A Meal and a Smile for Our Children',
            description: 'How our children care program brought warmth and dignity.',
            icon: 'https://venkatadrisevatrust.com/assets/img/stories/meal-smile.png',
            fallbackIcon: faHeart,
            color: '#e91e63'
        },
        {
            id: 2,
            title: 'A School Bag, A Dream, A Future',
            description: 'Education support that helped a young girl from a rural village stay in school and aspire to become a teacher.',
            icon: 'https://venkatadrisevatrust.com/assets/img/stories/school-bag.png',
            fallbackIcon: faBook,
            color: '#2196f3'
        },
        {
            id: 3,
            title: 'Health Camp Brings Hope to a Remote Village',
            description: 'Over 200 people received free medical checkups and medicines through our mobile health initiative.',
            icon: 'https://venkatadrisevatrust.com/assets/img/stories/health-camp.png',
            fallbackIcon: faUserMd,
            color: '#4caf50'
        }
    ];

    // Enhanced image component with fallback
    const SafeImage = ({ src, alt, fallbackIcon, maxWidth = 160, maxHeight = 100, style = {} }) => {
        const [errored, setErrored] = useState(false);

        if (errored || !src) {
            return (
                <FontAwesomeIcon
                    icon={fallbackIcon || faNewspaper}
                    style={{
                        fontSize: Math.min(maxWidth, maxHeight) * 0.6,
                        color: '#0056b3',
                        ...style
                    }}
                />
            );
        }

        return (
            <img
                src={src}
                alt={alt}
                onError={() => setErrored(true)}
                style={{
                    maxWidth: maxWidth,
                    maxHeight: maxHeight,
                    width: 'auto',
                    height: 'auto',
                    objectFit: 'contain',
                    display: 'block',
                    ...style
                }}
            />
        );
    };

    return (
        <section className="py-5" style={{ backgroundColor: '#e3f2fd' }}>
            <Container>
                {/* Page Header */}
                <Row className="mb-5">
                    <Col className="text-center">
                        <h1 className="display-4 fw-bold">
                            <FontAwesomeIcon icon={faNewspaper} className="text-primary me-3" />
                            Our Publications
                        </h1>
                        <div
                            className="divider mx-auto"
                            style={{
                                width: '80px',
                                height: '4px',
                                background: 'linear-gradient(90deg, #0056b3, #007bff)',
                                marginBottom: '1rem'
                            }}
                        />
                        <p className="lead text-muted fw-medium">
                            Explore our network of media platforms and community initiatives
                        </p>
                    </Col>
                </Row>

                {/* ============ PUBLICATIONS GRID ============ */}
                <Row className="mb-5">
                    {publications.map((pub) => (
                        <Col md={6} lg={3} key={pub.id} className="mb-4">
                            <Card className="h-100 shadow-lg border-0 hover-shadow transition">
                                {/* ⚪ WHITE background for logo */}
                                <div
                                    className="d-flex align-items-center justify-content-center"
                                    style={{
                                        backgroundColor: '#ffffff',
                                        minHeight: '180px',
                                        padding: '25px 20px',
                                        borderBottom: '3px solid ' + pub.color
                                    }}
                                >
                                    <SafeImage
                                        src={pub.icon}
                                        alt={pub.name}
                                        fallbackIcon={faNewspaper}
                                        maxWidth={220}
                                        maxHeight={130}
                                    />
                                </div>

                                <Card.Body className="d-flex flex-column">
                                    <div className="mb-2">
                                        <Badge bg="primary" className="me-2">
                                            {pub.category}
                                        </Badge>
                                    </div>
                                    <Card.Title className="fw-bold">{pub.name}</Card.Title>
                                    <Card.Text className="text-muted small flex-grow-1">
                                        {pub.description}
                                    </Card.Text>
                                    <Button
                                        variant="outline-primary"
                                        href={pub.url}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="rounded-pill mt-2"
                                    >
                                        Visit <FontAwesomeIcon icon={faExternalLinkAlt} className="ms-2" />
                                    </Button>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>

                {/* ============ SERVICE AREAS ============ */}
                <Row className="mb-5">
                    <Col>
                        <h2 className="fw-bold mb-4 pb-2 border-bottom border-primary">
                            <FontAwesomeIcon icon={faHandsHelping} className="text-primary me-2" />
                            Our Areas of Service
                        </h2>
                        <p className="text-muted mb-4">Reaching out with love, dignity, and hope</p>
                        <Row xs={1} md={2} lg={3} className="g-4">
                            {serviceAreas.map((service, index) => (
                                <Col key={index}>
                                    <Card className="h-100 shadow-sm border-0 hover-shadow transition text-center">
                                        <Card.Body>
                                            {/* ⚪ WHITE circle for service logo */}
                                            <div
                                                className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                                                style={{
                                                    width: '150px',
                                                    height: '150px',
                                                    backgroundColor: '#ffffff',
                                                    padding: '25px',
                                                    border: '3px solid ' + service.color,
                                                    boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
                                                }}
                                            >
                                                <SafeImage
                                                    src={service.icon}
                                                    alt={service.title}
                                                    fallbackIcon={service.fallbackIcon}
                                                    maxWidth={100}
                                                    maxHeight={100}
                                                />
                                            </div>
                                            <Card.Title className="fs-6 fw-bold">{service.title}</Card.Title>
                                            <Card.Text className="small text-muted">
                                                {service.description}
                                            </Card.Text>
                                            <Button
                                                variant="link"
                                                className="text-primary text-decoration-none p-0"
                                            >
                                                Learn more →
                                            </Button>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </Col>
                </Row>

                {/* ============ IMPACT STORIES ============ */}
                <Row className="mb-5">
                    <Col>
                        <h2 className="fw-bold mb-4 pb-2 border-bottom border-primary">
                            <FontAwesomeIcon icon={faHeart} className="text-primary me-2" />
                            Our Impact Stories
                        </h2>
                        <Row xs={1} md={3} className="g-4">
                            {impactStories.map((story) => (
                                <Col key={story.id}>
                                    <Card className="h-100 shadow-sm border-0 hover-shadow transition">
                                        <Card.Body className="text-center p-4">
                                            {/* ⚪ WHITE circle for story logo */}
                                            <div
                                                className="rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                                                style={{
                                                    width: '160px',
                                                    height: '160px',
                                                    backgroundColor: '#ffffff',
                                                    padding: '30px',
                                                    border: '3px solid ' + story.color,
                                                    boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
                                                }}
                                            >
                                                <SafeImage
                                                    src={story.icon}
                                                    alt={story.title}
                                                    fallbackIcon={story.fallbackIcon}
                                                    maxWidth={100}
                                                    maxHeight={100}
                                                />
                                            </div>
                                            <Card.Title className="fs-6 fw-bold">{story.title}</Card.Title>
                                            <Card.Text className="small text-muted">
                                                {story.description}
                                            </Card.Text>
                                            <Button
                                                variant="link"
                                                className="text-primary text-decoration-none p-0"
                                            >
                                                Read More →
                                            </Button>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    </Col>
                </Row>

                {/* ============ TRUST CTA ============ */}
                <Row className="mt-4">
                    <Col>
                        <Card className="bg-primary text-white border-0 shadow-lg">
                            <Card.Body className="p-4 text-center">
                                <h4 className="fw-bold mb-3">
                                    <FontAwesomeIcon icon={faHandHoldingHeart} className="me-2" />
                                    Venkatadri Seva Trust
                                </h4>
                                <p className="mb-3">
                                    Watch Our Work in Action — See how your support is transforming lives.
                                </p>
                                <div className="d-flex flex-wrap justify-content-center gap-3">
                                    <Button
                                        variant="light"
                                        href="https://venkatadrisevatrust.com"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="rounded-pill px-4"
                                    >
                                        <FontAwesomeIcon icon={faExternalLinkAlt} className="me-2" />
                                        Visit Trust Website
                                    </Button>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                {/* ============ QUICK LINKS ============ */}
                
            </Container>

            {/* Custom CSS for hover effects */}
            <style jsx>{`
                .hover-shadow {
                    transition: transform 0.3s ease, box-shadow 0.3s ease;
                }
                .hover-shadow:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1) !important;
                }
                .transition {
                    transition: all 0.3s ease;
                }
            `}</style>
        </section>
    );
};

export default Publications;